import { render, staticRenderFns } from "./OrderRecycling.vue?vue&type=template&id=49c09996&scoped=true&"
import script from "./OrderRecycling.vue?vue&type=script&lang=js&"
export * from "./OrderRecycling.vue?vue&type=script&lang=js&"
import style0 from "./OrderRecycling.vue?vue&type=style&index=0&id=49c09996&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49c09996",
  null
  
)

export default component.exports